import React from 'react';
import { darkenColor } from '../../utils/colors';
import styles from '../../styles/layout/ThemedBackground.module.css';

/**
 * Themed background with animated parallax shapes
 * Used for game pages to provide visual consistency with game landing pages
 * 
 * @param {string} backgroundColor - The base color for the background
 * @param {number} darkenPercent - How much to darken the shapes (default: 15)
 * @param {string} className - Additional CSS class
 */
const ThemedBackground = ({ 
  backgroundColor, 
  darkenPercent = 15,
  className = '' 
}) => {
  if (!backgroundColor) return null;
  
  const shapeColor = darkenColor(backgroundColor, darkenPercent);
  
  return (
    <div 
      className={`${styles.background} ${className}`} 
      style={{ backgroundColor }}
    >
      <div className={styles.shapesContainer}>
        <div 
          className={`${styles.shape} ${styles.shape1}`} 
          style={{ backgroundColor: shapeColor }} 
        />
        <div 
          className={`${styles.shape} ${styles.shape2}`} 
          style={{ backgroundColor: shapeColor }} 
        />
        <div 
          className={`${styles.shape} ${styles.shape3}`} 
          style={{ backgroundColor: shapeColor }} 
        />
        <div 
          className={`${styles.shape} ${styles.shape4}`} 
          style={{ backgroundColor: shapeColor }} 
        />
        <div 
          className={`${styles.shape} ${styles.shape5}`} 
          style={{ backgroundColor: shapeColor }} 
        />
      </div>
    </div>
  );
};

export default ThemedBackground;


